export default "__VITE_ASSET__b443f86b__"